/**
 * @license
 *
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Type of color scheme
 */
export enum COLOR_SCHEME {
  /**
   * Regular color scheme
   */
  REGULAR = 'regular',

  /**
   * Layer color scheme
   */
  LAYER = 'layer',

  /**
   * Cyan color scheme
   */
  CYAN = 'cyan',

  /**
   * Purple color scheme
   */
  PURPLE = 'purple',
}
